// Lib
import React from 'react';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { areCustomTemplatesInitialised, isAppInitCompleted } from '../../../app/initialisation/initialisationSelector';

// Actions
import { fetchCurrentUserInitialCustomTemplates } from '../../../user/currentUserActions';

// Types
import { ImmutableMap } from '../../../../common/utils/immutableHelper';

type CustomTemplateLoaderProps = {
    isAppInitCompleted: boolean;
    customTemplatesInitialised: boolean;
    dispatchFetchCurrentUserInitialCustomTemplates: Function;
};

const mapStateToProps = createStructuredSelector({
    customTemplatesInitialised: areCustomTemplatesInitialised,
    isAppInitCompleted,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<ImmutableMap, void, Action>) => ({
    dispatchFetchCurrentUserInitialCustomTemplates: () => dispatch(fetchCurrentUserInitialCustomTemplates()),
});

/**
 * Loads the custom templates after the app is initialised and the template popup shows up,
 * if the custom templates haven't been loaded already.
 */
const CustomTemplateLoader = (props: CustomTemplateLoaderProps): null => {
    const { isAppInitCompleted, customTemplatesInitialised, dispatchFetchCurrentUserInitialCustomTemplates } = props;

    React.useEffect(() => {
        if (customTemplatesInitialised) return;

        dispatchFetchCurrentUserInitialCustomTemplates();
    }, [isAppInitCompleted]);

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomTemplateLoader);
